import React, { useEffect, useRef, useState } from "react";
import {
  addDynamicFormToEntityIDUnAuthorized,
  getDynamicFormDataUnAuthorized,
  getFormByEntityIdUnAuthorized,
  saveFormResponseUnAuthorized,
} from "../api/formBuilder";
import OnBoardingForm from "./OnBoardingForm";
import Toast from "../components/common/Toasts/Toast";
import Header from "../components/Header";
import "./OnBoardingFormContainer.scss";
import SuccessMessage from "../components/SuccessMessage";

function OnBoardingFormContainer({ history }) {
  const [jsonSchema, setSchema] = useState({});
  const [preFillData, setPreFillData] = useState(null);
  const [successMessage, setSuccessMessage] = useState(false);
  const urlParams = new URLSearchParams(history.location.search);
  const entityId = urlParams.get("leadId");

  const toastRef = useRef();

  const showToast = (toast) => {
    toastRef?.current?.addToast({
      type: toast.type,
      message: toast.message ? toast.message : "Something Went Wrong ",
    });
  };

  const getFormData = async (id = "") => {
    const result = await getDynamicFormDataUnAuthorized("0", id);
    if (result.status === 1) {
      setSchema(result.data?.content?.[0]);
      getFormDataById(entityId);
    }
  };
  const getFormDataById = async (entityId) => {
    const result = await getFormByEntityIdUnAuthorized(entityId);

    if (result.status === 1) {
      setPreFillData([...result.data?.content]);
    }
  };

  const postFormData = async (postData) => {
    let jsonObj = {};
    if (preFillData?.length > 0) {
      jsonObj = {
        id: preFillData?.[0]?.id,
        response: postData?.data,
      };
    } else {
      jsonObj = {
        formDataIds: [jsonSchema?.id],
        id: jsonSchema?.id,
        entityType: "LEAD",
        entityId: entityId,
        entityName: "ONBOARDING-FORM",
        response: postData?.data,
      };
    }

    const saveFormApi =
      preFillData?.length > 0
        ? saveFormResponseUnAuthorized
        : addDynamicFormToEntityIDUnAuthorized;
    const result = await saveFormApi(jsonObj);

    if (result?.status === 1) {
      showToast({
        type: "success",
        message: result.message ? result.message : "Successfully Submitted",
      });
      setSuccessMessage(true);
    } else {
      showToast({
        type: "error",
        message: result.errorDescription
          ? result.errorDescription
          : "Failed to Submit ",
      });
      setSuccessMessage(false);
    }
  };

  useEffect(() => {
    getFormData();
  }, []);

  return (
    <div styleName="base">
      <Header login={true} />
      <div styleName="content">
        <div styleName="form-base">
          {successMessage ? (
            <SuccessMessage />
          ) : (
            <OnBoardingForm
              jsonSchema={jsonSchema}
              postFormData={postFormData}
              preFillData={preFillData}
            />
          )}
          <Toast ref={toastRef} />
        </div>
      </div>
    </div>
  );
}

export default OnBoardingFormContainer;
